'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';
import SplitText from 'SplitText';



export class ViewText extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._width = 0;
    this._height = 0;
    this._count = 3;
    this._words = this.dataset.words;
    this.onResize = e => this._onResize(e);
  }
  connectedCallback() {
    this._onResize();
    resizeStore.eventEmitter.subscribe(this.onResize);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.unsubscribe(this.onResize);
  }
  _onResize() {
    const bounds = this.getBoundingClientRect();

    if (this._width === bounds.width && this._height === bounds.height) return;

    this._width = bounds.width;
    this._height = bounds.height;

    if (this._split) this._split.revert();

    this._split = new SplitText(this, {type: 'lines', linesClass: 'view-text-line-container'});

    this._split.lines.forEach(line => {
      const content = line.innerHTML;
      const div = document.createElement('div');
      div.classList.add('view-text-line');
      div.innerHTML = content;

      for (let i = 0; this._count > i; i++) {
        div.insertAdjacentHTML('afterbegin', `<div class='view-text-line-inner'><span>${content}</span></div>`);
      }

      line.innerHTML = '';
      line.appendChild(div);

      if (this._words) {
        setTimeout(() => {
          div.style.setProperty('--xx', `${line.offsetWidth - div.offsetWidth}px`);
          // div.style.width = `${line.offsetWidth + (line.offsetWidth - div.offsetWidth)}px`;
          // line.style.setProperty('--delay', `${Math.random() * 5}s`)
        }, 100)
      }
    })
  }
}


window.customElements.define('view-text', ViewText);